<template>
    <div class="field" :class="[ { 'no-placeholder': !label, 'loading': isLoading } ]">
        <div class="input-group">
            <select
                :name="name"
                class="input"
                :required="isRequired"
                :disabled="disabled"
                @change="handleChange"
                @focus="handleFocus"
                @blur="handleBlur"
                ref="select"
            >
                <option v-for="option in localOptions" :key="option.value" :value="option.value" :selected="option.selected">
                    {{ option.label }}
                </option>
            </select>
            <span>{{ label }}</span>
            <span class="icons"></span>
        </div>
        <strong class="tip" v-if="tip">{{ tip }}</strong>
    </div>
</template>

<script>
import axios from '@/store/axios';

export default {
    name: "SelectField",
    props: {
        name: {
            type: String,
            default: "",
        },
        label: {
            type: String,
            default: "",
        },
        value: {
            type: [String, Number, Object],
            default: ""
        },
        required: {
            type: String,
            default: ""
        },
        tip: {
            type: String,
            default: ""
        },
        options: {
            type: Array,
            default: () => []
        },
        api: {
            type: Array,
            default: () => []
        },
        disabled: {
            type: Boolean,
            default: false
        },
    },
    emits: [
        "value-updated",
        "event:blur",
        "event:focus",
        "event:change"
    ],
    data() {
        return {
            localOptions: [],
            alreadyLoaded: false,
            isLoading: true,
        };
    },
    updated() {
        if (this.alreadyLoaded) return;
        if(this.value && !this.isLoading) {
            const select = this.$el.querySelector(`select[name="${this.name}"]`);
            if (select) {
                select.value = this.value;
            }
            this.alreadyLoaded = true;
        }
    },
    watch: {
        value(newValue) {
            const select = this.$refs.select;
            if (select) {
                select.value = newValue;
            }            
        },
    },
    mounted() {
        this.localOptions = this.options.map(option => ({
            ...option,
            // selected: option.value === this.value
        }));
        // Carrega os dados da API se a URL for fornecida
        if (this.api.length > 0 && this.api[0].url) {
            const path = this.api[0].url;
            const apiUrl = path;
            // setTimeout(() => {
                axios.get(apiUrl)
                .then(response => {
                    let new_options = [];
                    const data = response.data?.data || null;
                    if (data) {
                        new_options = data.map(item => ({
                            label: item[this.api[0].label],
                            value: item[this.api[0].value]
                        }));
                    }
                    if(new_options.length > 0) {
                        this.localOptions = [...this.localOptions, ...new_options];
                    }
                    this.isLoading = false;
                })
                .catch(error => {
                    console.error("Error fetching data from API:", error);
                    this.isLoading = false;
                });
            // }, 100);
        }
        else {
            this.isLoading = false;
        }
    },
    computed: {
        isRequired() {
            return this.required === 'required' ? this.required : false;
        }
    },
    methods: {
        handleChange(event) {
            this.$emit("event:change", event.target.value);
            this.$emit("value-updated", { key: this.name, value: event.target.value, type: this.type });
        },
        handleBlur() {
            this.$emit('event:blur');
        },
        handleFocus() {
            this.$emit('event:focus');
        },
        // updateInitialValue(value) {
        //     console.log("Updating select field value:", value);
        //     const select = this.$el.querySelector(`select[name="${this.name}"]`);
        //     if (select) {
        //         select.value = value;
        //     }
        // }
    },
};
</script>
